// extracted by mini-css-extract-plugin
var _1 = "BottomBar__brandBorder--A4bQZ OfficeGeneral__bgBrand--eP1r7 OfficeGeneral__bg--fm0ad TopGeneral__bgSize--LtApb OfficeGeneral__bgBrandBase--duULG";
var _2 = "BottomBar__container--A4SSa OfficeGeneral__robotoLight--EHotF CoreGeneral__robotoLight--Ohjuq OfficeGeneral__sectionContent--CCJVl";
var _3 = "BottomBar__containerBottom--biekH";
var _4 = "BottomBar__content--VYuQw BottomBar__gutters--zY069 OfficeGeneral__gutterLeft--SGn7N OfficeGeneral__gutterRight--jXtq1";
var _5 = "BottomBar__copyright--X2XPu BottomBar__gutters--zY069 OfficeGeneral__gutterLeft--SGn7N OfficeGeneral__gutterRight--jXtq1 OfficeGeneral__textSizeE--FLfSm CoreGeneral__textSizeE--Rd1k3";
var _6 = "BottomBar__external--xD72s";
var _7 = "BottomBar__gutters--zY069 OfficeGeneral__gutterLeft--SGn7N OfficeGeneral__gutterRight--jXtq1";
var _8 = "BottomBar__links--D3stp";
var _9 = "BottomBar__logos--E6wGm BottomBar__gutters--zY069 OfficeGeneral__gutterLeft--SGn7N OfficeGeneral__gutterRight--jXtq1";
var _a = "BottomBar__main--MbYLC";
var _b = "BottomBar__mainLinks--qGtVm";
var _c = "BottomBar__mainLogo--XOX1J";
var _d = "BottomBar__signUp--zruQS";
var _e = "BottomBar__signup--_CrFY";
var _f = "BottomBar__simplerBar--Sc_rE";
var _10 = "BottomBar__smIcon--bGk0G";
var _11 = "BottomBar__socialMedia--mZfxq";
var _12 = "BottomBar__termsPrivacy--BiuSv";
var _13 = "BottomBar__text--g9MtI";
export { _1 as "brandBorder", _2 as "container", _3 as "containerBottom", _4 as "content", _5 as "copyright", _6 as "external", _7 as "gutters", _8 as "links", _9 as "logos", _a as "main", _b as "mainLinks", _c as "mainLogo", _d as "signUp", _e as "signup", _f as "simplerBar", _10 as "smIcon", _11 as "socialMedia", _12 as "termsPrivacy", _13 as "text" }
